define("ember-engines/-private/controller-ext", ["@ember/controller", "@ember/application"], function (_controller, _application) {
  "use strict";

  _controller.default.reopen({
    /*
      Creates an aliased form of a method that properly resolves external routes.
    */
    transitionToExternalRoute(routeName) {
      let externalRoute = (0, _application.getOwner)(this)._getExternalRoute(routeName);
      let target = this.target;
      let method = target.transitionToRoute || target.transitionTo;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return method.apply(target, [externalRoute, ...args]);
    }
  });
});